import CopyableList from "./CopyableList";
export default CopyableList